import ReactGA from 'react-ga';
import React, { Component } from 'react';
import { Route, BrowserRouter, Switch } from 'react-router-dom';

import ReactPixel from 'react-facebook-pixel';
import LoginForm from './dashBoard/LoginForm'
//import NewOrderForm from './NewOrderForm'
import '../App.css';
import '../algolia-min.css';
import NewOrderForm from './orderProcess/NewOrderForm'
import {
  firebaseAuth,
  base,
  new_pixel_id,
} from '../config/constants';
import { log } from '../Utilities/Utils'
//-------: DASHBOARD STUFF

import MainDashboard from './dashBoard/MainDashboard'
import { logout } from '../Utilities/FireBaseUtils'
import * as UiConsts from '../config/UiConstants'
//TEAMPLATES
import ViewTemplatesByType from './newSite/templates/ViewTemplatesByType'
import ViewTemplateSubCats from './newSite/templates/ViewTemplateSubCats'
import OrderComplete from './newSite/OrderComplete'

//NEW STUFF
import OrderForm from './newSite/orderForm'

import createBrowserHistory from 'history/createBrowserHistory';
import PreviewImage from './newSite/ImagePreview/PreviewImage';
import { TemplateOrderForm } from './newSite/templates/TemplateOrderForm';
//import ViewImage from './newSite/ViewImage/ViewImage';
// import SingleOrderView from './newSite/SingleOrderView/SingleOrderView';
// import SingleOrderViewPhone from './newSite/SingleOrderView/SingleOrderViewPhone';

//import StatusSpecificView from './newSite/StatusSpecificViews/StatusSpecificView';
import CountryViews from './newSite/StatusSpecificViews/CountryViews';

import HomepageLayout from './newSite/OnlineShop/OnlineShop';
//import SingleOrderViewDirect from './newSite/SingleOrderView/SingleOrderViewDirect';
import GoogleSheetsUpdate from './dashBoard/newDashboard/GoogleSheetsUpdate/GoogleSheetsUpdate';
import queryString from 'query-string'
import { sentTrackingParams, send_facebook_viewContent } from './newSite/MiscUtils';
import DesignChatView from './newSite/DesignChat/DesignChatView';
import DesignChatFinalScreen from './newSite/DesignChat/DesignChatFinalScreen';
import ArtistDashboard from './dashBoard/newDashboard/artists/ArtistDashboard';
import ArtistLoginForm from './dashBoard/newDashboard/artists/ArtistLoginForm';
//'./newDashboard/algoliaDashboard/AlgoliaMiscUtils'
import { checkAdminEmail } from './dashBoard/newDashboard/algoliaDashboard/AlgoliaMiscUtils';
import Privacy from './newSite/Privacy';

const history = createBrowserHistory({ forceRefresh: true });
history.listen(location => ReactGA.pageview(location.pathname));

ReactPixel.init(new_pixel_id);


class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authed: false,
      admin: false,
      //loading:true,
      loading: false,
      user: '',
      uid: '',
      userFromFirebaseUserNode: '',
      usersOrders: []
    }

    // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
    ReactGA.initialize('UA-105829922-1');

    // This just needs to be called once since we have no routes in this case.
    // ReactGA.pageview(window.location.pathname);


    this.checkForUserInUserNode = this.checkForUserInUserNode.bind(this);
    this.updateUserDetails = this.updateUserDetails.bind(this);
    this.mainAppLogout = this.mainAppLogout.bind(this);

  }


  componentDidMount() {
    console.log("++++++++++:app.js componentDidMount");
    // console.log("this.props.user.email:" + this.props.user.email);
    this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
      console.log("elx1 +++++++++:removeListener");

      if (user) {
        //console.log("maddx241 user is:" + user.email);

        if (user.email) {
         // console.log("addx290 user.email  is:" + user.email);
          this.setState({
            user: user,
            userFromFirebaseUserNode: user,
          })

          //CHECK ALGOLIA FOR USER
          checkAdminEmail(user.email, this.setAdminResult)
        }

      } else {
        console.log("rlx121 user NOT found");

        this.doAnonymousSignIn();
        this.setState({
          authed: false,
          // loading: false,
          user: user,
          uid: user.uid
        })
      }

    })
  }

  

  setAdminResult = (returnObject) => {
    console.log("++++++ addx294 setAdminResult");
    //console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

    if (returnObject.isAdminEmail) {
      this.setState({
        authed: true,
        admin: true,
        // loading: false,
        loading: false,
        algoliaUser: returnObject.algoliaUser,
        isAdmin: returnObject.isAdmin,
      })
    } else {
      this.setState({
        admin: false,
        loading: false,
      })

      //track user page view
      ReactPixel.pageView('/homepage');
      ReactGA.pageview('/homepage');

      //PIXEL LOG VIEW CONTENT
      console.log("qxx1:" + window.location.search);

      const parsed = queryString.parse(window.location.search);
      // console.log(parsed);

      // console.log("qxx12 utm_source:" + parsed.utm_source);
      // console.log("qxx12 utm_medium:" + parsed.utm_medium);
      // console.log("qxx12 utm_campaign:" + parsed.utm_campaign);
      // console.log("qxx12 utm_content:" + parsed.utm_content);

      //TRACK PARAMS
      sentTrackingParams(parsed);

      if (parsed.utm_campaign) {
        console.log("umtt01 parsed.utm_campaign exists.. calling..send_facebook_viewContent");

        let audience = "none";
        if (parsed.utm_source) {
          console.log("umtt011 parsed.utm_source exists:" + parsed.utm_source);
          audience = parsed.utm_source.split("aud_")[1];
          console.log("umtt013 got audience:" + audience);
        }

        send_facebook_viewContent(parsed.utm_campaign, audience);



      }
    }
  }




  checkForUserInUserNode(userUid) {
    console.log("rlx13 ++++++++:checkForUserInUserNode");
    console.log("rlx14 userUid:" + userUid);

    base.fetch('users', {
      context: this,
      asArray: true,
      queries: {
        orderByChild: 'uid',
        equalTo: userUid
      },
      then(data) {
        console.log("rlx141 foundUser:" + JSON.stringify(data));

        if (data.length > 0) {
          log("rlx15 found existing user in users node");

          this.setState({ userFromFirebaseUserNode: data[0] })
          // userFromFirebaseUserNode = data[0];
          // log("rlx16 get userFromFirebaseUserNode?:"+data[0].email);

        } else {
          log("rlx151 user NOT found");
          this.updateUserDetails(userUid);
        }

        //remove loading
        this.setState({ loading: false })
      }
    });
  }

  updateUserDetails(userUid) {
    console.log("++++++updateuserDetails");
    console.log("userUid:" + userUid);
    base.update('users/' + userUid, {
      data: { uid: userUid },
      then(err) {
        if (!err) {
          console.log("updated no error");
          // Router.transitionTo('dashboard');
          //bears endpint is now {name: 'George', type: 'Grizzly'}
        }
      }
    });
  }

  doAnonymousSignIn() {
    firebaseAuth().signInAnonymously().catch(function (error) {
      // Handle Errors here.
      //var errorCode = error.code;
      //var errorMessage = error.message;
      // ...
    });
  }

  componentWillUnmount() {
    this.removeListener()
  }

  mainAppLogout() {
    log("++++++++:mainAppLogout");
    logout();
    // this.props.history.push('/dashboard/login');
    //  this.context.history.push('/dashboard/login')
    //  const { router } = this.context;
    // router.transitionTo('/dashboard/login')
    history.push("/login");
  }

  render() {
    return (this.state.loading === true ? <UiConsts.LoadingComponent /> :

      <BrowserRouter>
        <Switch>
          {/* <Route exact path='/' component={MainMenu} /> */}
          {/* <Route exact path='/' render = {() => <MainMenu logOutFunction={this.mainAppLogout}
           usersOrders={this.state.usersOrders}/>} /> */}

          <Route exact path='/' component={OrderForm} />
          <Route exact path='/orderForm' component={OrderForm} />
          <Route exact path='/cranes' component={OrderForm} />
          <Route exact path='/football' component={OrderForm} />

          {/* FB tracking */}
          <Route exact path='/fb/:fbId' component={OrderForm} />
          <Route exact path='/fb/:campaign/:fbId' component={OrderForm} />
          <Route exact path='/fb/:campaign/:adset/:fbId' component={OrderForm} />

          <Route exact path='/football/manu' component={OrderForm} />
          <Route exact path='/football/arsenal' component={OrderForm} />
          <Route exact path='/football/chelsea' component={OrderForm} />
          <Route exact path='/business' component={OrderForm} />
          <Route exact path='/imagePreview' component={PreviewImage} />


          {/* ----------  ViewTemplatesByType --------------- */}
          {/* NORMAL STANDARD ONE */}
          <Route exact path='/ViewTemplatesByType/:templateType' component={ViewTemplatesByType} />

          {/* WHEN STARTING FROM MAIN PAGE  - GET THE ADSET NAME */}
          <Route exact path='/ViewTemplatesByType/:templateType/:adset' component={ViewTemplatesByType} />

          {/* FB tracking  - WHEN STARTING FROM FB AD DIRECTLY */}
          {/* <Route exact path='/ViewTemplatesByType/:templateType/:fbId' component={ViewTemplatesByType} /> */}
          <Route exact path='/ViewTemplatesByType/:templateType/:campaign/:fbId' component={ViewTemplatesByType} />

          {/* FB tracking  WHEN STARTING FROM MAIN PAGE  - GET THE ADSET NAME */}
          <Route exact path='/ViewTemplatesByType/:templateType/:campaign/:fbId/:adset' component={ViewTemplatesByType} />

          {/*  BASIC ONE NO TRACK*/}
          <Route exact path='/viewCategory/:templateSubCategory' component={ViewTemplateSubCats} />

          {/* FB tracking */}
          <Route exact path='/viewCategory/:templateSubCategory/:fbId' component={ViewTemplateSubCats} />

          {/* ----------  TemplateOrderForm --------------- */}
          {/* <Route exact path='/TemplateOrderForm/:templateId' component={TemplateOrderForm} /> */}
          <Route exact path='/TemplateOrderForm/:templateId/:adset' component={TemplateOrderForm} />

          {/* ----------  shop --------------- */}
          <Route exact path='/shop/:templateType' component={ViewTemplatesByType} />
          <Route exact path='/shop/:templateType/:campaign/:fbId' component={ViewTemplatesByType} />
          {/* <Route exact path='/shop/:templateType/:campaign/:fbId/:adset' component={ViewTemplatesByType} /> */}
          <Route exact path='/shop/:templateType/:campaign/:adset/:fbId' component={ViewTemplatesByType} />

          <Route exact path='/OrderComplete' component={OrderComplete} />

          <Route exact path='/onlineShop' component={HomepageLayout} />

          <Route exact path='/CountryViews/:country' component={CountryViews} />

          {/* <Route exact path='/newOrder' component={NewOrderForm} />  */}
          <Route exact path='/newOrder' render={() => <NewOrderForm user={this.state.userFromFirebaseUserNode} />} />
          {/* <Route path='/viewOrder/:orderId' component={ViewOrder} /> */}

          {/* <PrivateRoute admin={this.state.admin} exact path='/dashboard' component={MainDashboard} /> */}
          <Route path='/dashboard' component={MainDashboard} />

          <Route path='/sendSuppliesList' component={GoogleSheetsUpdate} />

          <Route exact path='/admin/:specialEntry' component={OrderForm} />

          {/* CHAT WITH CLIENT ABOUT DESIGN */}
          {/* <Route exact path='/design/:orderKey' component={DesignChatView} />

          <Route exact path='/design/approved/:clientChoice' component={DesignChatFinalScreen} /> */}

          {/* ARTIST LOGIN */}
          {/* <Route path='/artistDashboard/:artist' component={ArtistDashboard} />
          <Route path='/artist/login' component={ArtistLoginForm} /> */}

          {/* REGISTRY */}
          {/* <Route path='/registry' component={RegistryPage1} />
          <Route path='/event/:selectedEvent' component={RegistryEventSelected} />
          <Route path='/reg/:wishListId' component={ViewWishListToBuy} />
          <Route path='/viewList/:phone' component={OwnerViewWishList} /> */}

          {/* PRIVACY */}
          <Route path='/privacy' component={Privacy} />

          <Route path='/login' component={LoginForm} />




        </Switch>
      </BrowserRouter>


      // <div className="App">
      //   <div className="App-header">
      //     <img src={logo} className="App-logo" alt="logo" />
      //     <h2>Welcome to React</h2>
      //   </div>
      //   <p className="App-intro">
      //     To get started, edit <code>src/App.js</code> and save to reload.
      //   </p>
      // </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js